module.exports = __webpack_public_path__ + "static/pov-56bd7fa023e207be60f8fc1d53c981f3.jpg";